export default __webpack_public_path__ + "static/media/comingSoon.d7131d17.png";